import { createClient } from '@/shared/api';
import type { GetUnreviewedReportsQuery, GetUnreviewedReportsQueryVariables } from '@/shared/api';
import GET_UNREVIEWED_REPORTS from '../queries/getUnreviewedReports';

/**
 * Loads the list of unreviewed reports for the inbox. Runs the getUnreviewedReports query and throws the returned message unless it reports success, otherwise yielding the reports.
 *
 * @param input - Query input selecting the unreviewed reports.
 * @returns A promise resolving to the unreviewed reports.
 */
const fetchGetUnreviewedReports = async (
  input: GetUnreviewedReportsQueryVariables['input'],
): Promise<NonNullable<GetUnreviewedReportsQuery['getUnreviewedReports']>['reports']> => {
  const client = createClient();
  const result = await client.query<GetUnreviewedReportsQuery, GetUnreviewedReportsQueryVariables>({
    query: GET_UNREVIEWED_REPORTS,
    variables: {
      input,
    },
  });
  const { data } = result;
  // API always returns this field for a resolved query; code already accessed it unconditionally.
  const { getUnreviewedReports } = data;
  if (!getUnreviewedReports!.isSuccess) {
    throw new Error(getUnreviewedReports!.message ?? undefined);
  }
  return getUnreviewedReports!.reports;
};

export default fetchGetUnreviewedReports;
